var render, staticRenderFns
import script from "./NBtn2.vue?vue&type=script&lang=js"
export * from "./NBtn2.vue?vue&type=script&lang=js"
import style0 from "./NBtn2.vue?vue&type=style&index=0&id=2b88d33a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports